import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getRoomsTypes = async () => {
  return await request.get(
    `/RentPlace/office/type`,
    {},
    'При загрузке типов офисов произошла ошибка',
    []
  );
};

const useRoomsTypes = () =>
  useQuery([queries.officesTypes], () => getRoomsTypes(), {
    placeholderData: [],
  });

export default useRoomsTypes;
